module.exports = __webpack_public_path__ + "static/img/guide3.38f1440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide3.png
// module id = pgy5
// module chunks = 0